<template>
  <transition
      v-on:before-enter="beforeEnter"
      name="fade">
    <div class="modal-backdrop" v-on:click="close">
      <div class="modal" @click.stop>
        <div style="width: 100%;">
          <button
            class="close-button"
            id="singlebutton"
            name="singlebutton"
            v-on:click="close"
          >
            &#10005;
          </button>
        </div>
        <transition name="fade" mode='out-in'>
          <article
              v-if="!signedUp && !completed"
              class="content article-text"
              key="sign-up-text">
            We're currently exploring this concept and can let you know when
            it's open to the public. Please sign up below to get the latest
            developments.
          </article>
          <article
              v-if="signedUp"
              class="content article-text"
              key="send-mail-text">
            Thank you for signing up! If you'd like to encourage organizations
            in {{ selectedCountry }} to explore this concept, please send them an
            email by clicking the button below!
          </article>
          <article
              v-if="completed"
              class="content article-text"
              style="padding-bottom: 0px;"
              key="thank-you-text">
            Thank you for helping us make this pension concept a reality! We'll
            keep you up to date with the latest developments.
          </article>
        </transition>
        <transition name="fade" mode='out-in'>
          <form v-if="!completed" class="formCont" style="width:100%;" v-on:submit.prevent="">
            <p class="form-field">
              <span class="field">
                <input
                  placeholder="name"
                  class="form-control"
                  type="text"
                  :disabled="signedUp || completed"
                  v-model="name"
                />
                <div class="error" v-if="validName=='null-name'">
                  Please enter your name
                </div>
              </span>
            </p>
            <p class="form-field">
              <span class="field">
                <input
                  placeholder="email"
                  class="form-control"
                  type="text"
                  :disabled="signedUp || completed"
                  v-model="email"
                />
                <div class="error" v-if="validEmail=='null-email'">
                  Please enter your email address
                </div>
                <div class="error" v-else-if="validEmail=='invalid-address'">
                  Please enter a valid email address
                </div>
              </span>
            </p>
          </form>
        </transition>

        <div class="form-group">
          <div class="col-md-12">
            <button
              v-if="stage=='email-form'"
              id="singlebutton"
              style="float: right;"
              name="singlebutton"
              class="btn btn-primary btn-submit"
              v-on:click="applyNow"
            >
                Apply Now
            </button>
            <button
              v-if="signedUp"
              id="singlebutton"
              style="float: right; background-color: #212f3a; border-color: #212f3a;"
              name="singlebutton"
              class="btn btn-primary btn-submit"
              v-on:click="sendEmail"
            >
              Email Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import emailList from '../assets/emailList.js'
import { mapGetters } from 'vuex'
import axios from 'axios'
import { required, between, minValue } from 'vuelidate/lib/validators'
import accounting from 'accounting'

export default {
  name: 'modal',
  data: function () {
    return {
      stage: 'email-form',
      name: null,
      email: null,
      validName: 'not-submitted',
      validEmail: 'not-submitted'
    }
  },
  validations() {
    return {
      name: {
        required,
      },
      email: {
        required,
        validAddress: this.validateEmail
      },
    }
  },
  computed: {
    ...mapGetters([
      'selectedCountry',
      'result'
    ]),
    signedUp: function(){
      return this.stage=='send-email'
    },
    completed: function(){
      return this.stage=='email-sent'
    }
  },
  methods: {
    validateEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    beforeEnter: function (el) {
      this.email = null
      this.name = null
      this.stage = 'email-form'
    },
    close() {
      this.$emit('close');
    },
    applyNow() {
      this.$v.name.$touch()
      this.$v.email.$touch()

      if (!this.$v.$invalid) {
        var url = process.env.VUE_APP_EMAIL_FORM_MACRO_URL;
        axios({
          url: `https://${url}?Name=${encodeURIComponent(this.name)}&Email=${encodeURIComponent(this.email)}`,
          method: "GET",
        })
        this.stage = 'send-email'
        this.validEmail = 'valid'
        this.validName = 'valid'
      }

      if (!this.$v.name.required) {
        this.validName = 'null-name'
      } else {
        this.validName = 'valid'
      }

      if (!this.$v.email.required) {
        this.validEmail = 'null-email'
      } else if (!this.$v.email.validAddress) {
        this.validEmail = 'invalid-address'
      } else {
        this.validEmail = 'valid'
      }
    },
    sendEmail() {
      this.stage = 'email-sent'
      var emailAddresses = emailList
        .filter((row)=>row[0] == this.selectedCountry)
        .map(row=>row[1])
      window.open(generateMailto(
        emailAddresses,
        this.name,
        this.result
      ),'_blank');
      // document.location.href = generateMailto(
      //   emailAddresses,
      //   this.name,
      //   this.result
      // );
    }
  }
};

function generateMailto(emails, name, data) {
// currentAge
  var body = `
Dear all,
%0d%0a
%0d%0a
I am writing you after seeing the AlliedCrowds Pension Calculator
 (https://www.alliedcrowds.com/pension). It is an interesting tool where
 individuals can calculate what it would cost to provide a pension to
 individuals in ${ data.country }, depending on age, life expectancy,
 retirement age, GDP, etc. One thing that I found surprising is how relatively
 inexpensive it might be to provide a pension in
 some countries. As an example, the estimated cost of providing a
 ${data.currentAge} year old ${ data.gender == 'female' ? 'woman': 'man' } from
 ${data.country} who retires at age ${data.agePaymentsStart} with a pension
 until the end of ${data.gender == 'female' ? 'her': 'his'} life is only
 ${accounting.formatMoney(data.totalCosts, "$", 0)}, based on what seem like
 reasonable assumptions. A combination of state budget, private sector and
 individual contributions, and the aid community would perhaps be able to fund
 this.
%0d%0a
%0d%0a
I am writing to encourage you to at least study and understand what it would
 take to potentially put a pension system in place. There are many obvious
 benefits from a functioning pension system that many more economically
 advanced countries benefit from and I think we should aspire to have one in
 ${data.country} as well. As a starting point, you could of course contact
 AlliedCrowds to understand their work better and how they might contribute.
%0d%0a
%0d%0a
Best regards,
%0d%0a
%0d%0a
${name}
`

  var subject = "Securing pensioners' income"
  var mailtoUrl = 'mailto:'
    + emails.reduce((cur, acc)=>acc + ',' + cur, '')
    + `?cc=info@alliedcrowds.com`
    + `&subject=${subject}&body=${body}`
  return mailtoUrl
}

</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  color: black;
  position: relative;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px grey;
  padding: 40px;
  display: flex;
  flex-direction: column;
}

.close-button {
  float: right;
  padding: 0px;
  border: 0px;
  font-size: 15px;
}

@media screen and (max-width: 480px){
  .modal {
    width: 80%;
  }
}
/* #### Tablets Portrait or Landscape #### */
@media screen and (min-width: 480px) and (max-width: 1050px){
  .modal {
    width: 80%;
  }
}

/* #### Desktops #### */
@media screen and (min-width: 1050px){
  .modal {
    width: 30%;
  }
}

.article-text {
  font-size: 20px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 30px;
  padding-top: 0px;
  color: black;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-enter-to, .fade-leave {
  opacity: 1;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

</style>
